import React from "react";
// import "./Classes.css";

function Classes() {
  return (
    <div className="content-container classes-page">
      <p>
        <i>
          COVID UPDATE There are no public group classes being held at this
          time.
          <br />
          Please sign up for our{" "}
          <b>
            <a href="https://forms.gle/iBdSjcaRsHPWthbD6">mailing list</a>
          </b>{" "}
          to stay update to date with information.
        </i>{" "}
      </p>
      <h2>Oakland Classes</h2>
      <p>
        If you are interested in becoming a member of EBM Kung Fu Oakland,
        please take the time to read this page.
      </p>
      <p>
        The curriculum of EBM Kung Fu consists of the traditional training of
        Northern Shaolin Kung Fu, Hsing I, Chi Kung and Tai Chi, and the more
        modern kung fu training system of San Shou / Sanda Kick Boxing. The
        traditional training builds the proper foundation in body mechanics and
        movement skills. The San Shou training builds realistic self defense
        ability, strength, endurance and confidence. The combination of the
        traditional arts with the contemporary applications makes for a very
        complete and versatile system.
      </p>
      <p>
        EBM Kung Fu does not have belt rankings or many of the formalisms of
        martial arts, but the training is rigorous and challenging. We ask that
        the first time you come to EBM that you observe a class to get a general
        sense of the training. Since consistency is the key to success in
        martial arts, we want people to know what they are getting into before
        making any commitments. We only want people who are serious and sincere
        in their interest in learning martial arts. We have no enrollment
        contracts. Contact us if you have any questions on tuition and
        enrollment.
      </p>
      <h3>Oakland Teachers</h3>
      <hr />
      <div>
        <div>
          <b>Brent H, Head Instructor</b>
          <br />
          <p>
            Brent is the head instructor of EBM Kung Fu and the founder of the
            Oakland San Shou Team. Brent has been training in martial arts for
            most of his life. Brent's teachers were Sifu Wong Jack Man (Hsing I,
            Tai Chi, Northern Shaolin Kung Fu), Sifu Kwan Sai Hung (Kung Fu, Chi
            Kung, Meditation), Cesar & Ralph Gracie (Brazilian Jiu Jitsu), Floyd
            Winter (Greco-Roman & Russian Sambo Wrestling). Brent also has a 2nd
            Degree Black Belt in full contact Karate under Charles Gordon. As a
            San Shou fighter in the 80 kilo class, Brent holds several titles
            including the USAWKF National Champion. Brent has served as the
            Coach of the US San Shou Team for two World Championships (Macau
            China, Hanoi Vietnam) and has coached 6 National San Shou Champions.
          </p>{" "}
        </div>
      </div>
      <hr />
      <div>
        <div>
          <b>Adam C, Instructor</b>
          <br />
          <p>
            Adam has been training at EBM since the start of the Oakland class
            in 1998. Before that Adam had a background in Karate. Adam is an
            expert in San Shou and often teaches the San Shou sparring class. As
            a San Shou competitor, Adam holds several titles including the
            USAWKF National Champion and the Cung Le Born to Fight II San Shou
            Super Fight Champion. Adam also studied Tai Chi with Wong Jack Man
            and is an avid practitioner of Astanga Yoga.
          </p>
        </div>
      </div>
      <hr />
      <div>
        <div>
          <b>Brian M, Instructor</b> <br />
          <p>
            Brian has been a student at EBM for over 20 years. Brian is an
            expert in San Shou, Northen Shaolin and Tai Chi. As a San Shou
            fighter in the 85-90 kilo class, Brian holds several titles
            including USAWKF National Champion and Pan-Am San Shou Champion.
            Brian has also competed in professional San Shou in China and has
            served as a US San Shou Team member. Brian is also a strength and
            conditioning trainer at UC Berkeley.
          </p>
        </div>
      </div>
      <hr />
      <div>
        <div>
          <b>Russ M, Instructor</b>
          <br />
          <p>
            Russ has been a student at EBM for over 15 years. Russ is an expert
            in San Shou, Hsing I and Northern Shaolin. Russ began his training
            at EBM with Northern Shaolin under David Tircuit, then became the
            first San Shou competitor on the Oakland San Shou Team. As a San
            Shou fighter in the 80 kilo class, Russ holds several titles
            including USAWKF National Champion and has competed in professional
            San Shou in China and has served as a US San Shou Team member. Russ
            is one of the very few non-Chinese fighters to win a pro San Shou
            fight in China.
          </p>
        </div>
      </div>
      <hr />
      <h3>Schedule</h3>
      Pending the re-opening
      <h3></h3>
    </div>
  );
}

export default Classes;
